import { Injectable, inject } from '@angular/core';

import { ConfigService } from '@shared/services/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class TokenExpireConfigService {
  private configService = inject(ConfigService);
  private tokenExpirationThresholdInMinutes: number = 15;
  private readonly MINUTES_TO_MS: number = 60000;

  public configTokenExpire(): void {
    this.configService.loadConfig().subscribe((config) => {
      const threshold = config?.TOKEN_EXPIRATION_THRESHOLD;
      this.tokenExpirationThresholdInMinutes = Number(threshold);
    });
  }

  public isTokenExpired(storedTokenExpiry: string): boolean {
    const expirationTime: number = new Date(storedTokenExpiry).getTime();
    const currentTime: number = Date.now();
    const timeDifference: number = expirationTime - currentTime;
    const thresholdMs: number = this.tokenExpirationThresholdInMinutes * this.MINUTES_TO_MS;
    const isTokenExpired: boolean = timeDifference <= thresholdMs || currentTime > expirationTime;

    return isTokenExpired;
  }
}
